import React, {  useEffect, useState } from 'react';

import "@bpmn-io/form-js/dist/assets/form-js-editor.css";
import "@bpmn-io/form-js/dist/assets/form-js.css";


import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import {
	setAction,
	setValidFunctions
} from './redux/appState';

import {
	useGetFormListQuery,
	databaseViewApi
} from './redux/databaseView';

import {
	useLogoutMutation,
} from './redux/authApi';


import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import {
	DialogActions,
	ListItemIcon
} from '@mui/material';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

var executingCommand = 0;


export interface SimpleDialogProps {
	open: boolean;
	selectedValue: string;
	setSelectedValue: () => void;
	onClose: (value: string) => void;
}


export function SimpleDialog(props: SimpleDialogProps)
	{
	const [selectedValue, setSelectedValue] = React.useState(null);

	const {
		onClose,
		open,
		type,
		onlyPublished,
		title,
		action
	} = props;

	const {
		data,
		error,
		isLoading
	} = useGetFormListQuery({
		type,
		active: !!onlyPublished,
		onFailure: 1
	});


	if (isLoading)
		return null;


	const items =
		!error && data?.success
			? data.data
			: [];


	const handleClose = async (value) =>
		{
		await onClose(value);
		setSelectedValue(null);
		};


	const handleDblClick = (item) =>
		{
		handleClose(item);
		};


	return (
		<Dialog
			open={open}
			onClose={() => handleClose(null)}
			maxWidth="sm"
			fullWidth={false}
			PaperProps={{
				sx: {
					minWidth: 400
				}
			}}
		>
			<DialogTitle>
				{title ?? "Select form to edit"}
			</DialogTitle>

			<List
				sx={{
					pt: 0,
					maxHeight: 400,
					overflowY: "auto"
				}}
			>
				{items.map((item) => (
					<ListItem
						disablePadding
						key={item.formid}
					>
						<ListItemButton
							selected={
								selectedValue?.formid === item.formid
							}
							onClick={() => setSelectedValue(item)}
							onDoubleClick={() => handleDblClick(item)}
							sx={{
								minHeight: 42,
								py: 0.5,
								px: 2
							}}
						>
							{type === "form" && (
								<ListItemIcon>
									{/* <DynamicFormIcon /> */}
								</ListItemIcon>
							)}

							<ListItemText
								primary={item.formid}
							/>
						</ListItemButton>
					</ListItem>
				))}
			</List>

			<DialogActions>

				<Button
					onClick={() => handleClose(null)}
				>
					Cancel
				</Button>

				<Button
					variant="contained"
					disabled={!selectedValue}
					onClick={() => handleClose(selectedValue)}
				>
					{action ?? "Open"}
				</Button>

			</DialogActions>
		</Dialog>
	);
}



export default function CommandIntercept(params)
	{
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [action, setDialogAction] = useState(null);
	const [title, setTitle] = useState(null);
	const [open, setOpen] = useState(false);
	const [selectFunction, setSelectFunction] = useState(null);
	const [fresh, setFresh] = useState(0);

	const type =
		params.getType
			? params.getType()
			: "form";

	const displayConversion = {
		diagram: 'process'
	};

	const displayType =
		displayConversion[type] ?? type;

	const [logout] = useLogoutMutation();

	const command = useSelector(
		(state) => state.appState.action
	);


	const handleClose = (value) =>
		{
		console.log("handleClose");

		setOpen(false);
		setDialogAction(null);
		setTitle(null);

		if (
			value &&
			selectFunction &&
			selectFunction.length
		)
			{
			console.log(
				selectFunction[0],
				value
			);

			selectFunction[0](value);
			}

		setSelectFunction(null);
		};


	useEffect(() =>
		{
		var menuObj = {};

		Object.keys(params).forEach((x) =>
			{
			if (x.startsWith("on"))
				{
				menuObj[x] = 1;
				}
			});

		// Logout is always available
		menuObj['onLogout'] = 1;

		dispatch(
			setValidFunctions(menuObj)
		);

		},
		[params, dispatch]
	);


	useEffect(() =>
		{
		setFresh(1);
		},
		[command]
	);


	if (
		!fresh ||
		executingCommand ||
		command === ""
	)
		{
		// Nothing to execute
		}
	else
		{
		executingCommand = 1;

		console.log("here");

		setFresh(0);


		async function perform(params, command)
			{
			try
				{
				command = "on" + command;

				console.log(command);


				/*
				 * LOGOUT
				 */
				if (command === "onLogout")
					{
					console.log("logging out");

					await logout().unwrap();

					/*
					 * Clear all cached RTK Query data.
					 *
					 * This includes getLoginStatus, so Layout()
					 * will immediately request the current login
					 * state again.
					 */
					dispatch(
						databaseViewApi.util.resetApiState()
					);

					/*
					 * Your route loader currently also uses
					 * localStorage userID.
					 */
					localStorage.removeItem('authToken');

					/*
					 * Return to the public root.
					 *
					 * replace prevents the authenticated page
					 * remaining immediately behind us in browser
					 * history.
					 */
					navigate(
						'/',
						{
							replace: true
						}
					);
					}


				/*
				 * DELETE
				 */
				else if (command === "onDelete")
					{
					setTitle(
						"Select " +
						displayType +
						" to delete"
					);

					setDialogAction("Delete");

					if (command in params)
						{
						/*
						 * Store function in an array so React
						 * doesn't interpret it as a state updater
						 * and execute it.
						 */
						setSelectFunction([
							params[command]
						]);
						}

					setOpen(true);
					}


				/*
				 * OPEN
				 */
				else if (command === "onOpen")
					{
					setTitle(
						"Select " +
						displayType +
						" to open"
					);

					console.log(
						"there",
						params[command]
					);

					if (command in params)
						{
						setSelectFunction([
							params[command]
						]);
						}

					setOpen(true);
					}


				/*
				 * ALL OTHER COMMANDS
				 */
				else if (command in params)
					{
					console.log("executing");

					await params[command](params);
					}

				}
			catch (e)
				{
				console.error(e);
				}


			executingCommand = 0;

			dispatch(
				setAction("")
			);
			}


		perform(
			params,
			command
		);
		}


	return (
		<div>

			<SimpleDialog
				open={open}
				title={title}
				action={action}
				onClose={handleClose}
				type={type}
			/>

		</div>
	);
	}